import {
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
  createTheme,
  responsiveFontSizes,
} from "@mui/material";
import { ReactNode } from "react";
import { components } from "./custom/component";
import { palette } from "./custom/palete";
import { typography } from "./custom/typography";
import { GlobalStyles } from "./global-styles";

type ThemeConfigProps = {
  children?: ReactNode;
};
export const ThemeConfig = ({ children }: ThemeConfigProps) => {
  let theme = responsiveFontSizes(
    createTheme({
      palette: palette,
      components: components,
      typography: typography,
      spacing: 8,
    })
  );

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
};
